module.exports = __webpack_public_path__ + "media/images/home/power-plate-386d1b1672670ddd59ae35a225ab2c5b.jpg";